import { P, Strong } from '@ahmdigital/ui';

import constants from '../../../ahm-constants';

const upgrade = {
  cta: 'Check out black 70 boost',
  id: constants.PRODUCT.BLACK_70_BOOST_EXTRAS,
  title: 'Looking for a percentage back cover?',
};

export default {
  description: (
    <P>
      From <Strong>braces</Strong> to <Strong>orthotics</Strong>, and even <Strong>pre and post natal services</Strong>.
    </P>
  ),
  getSellingPoints: () => [
    {
      description: 'Heaps of dental.',
      title: 'Holy molars?',
    },
    {
      description: 'on included extras.',
      title: 'No 2 or 6 month waiting periods',
    },
    {
      description: 'Available at select dentists.',
      title: 'No gap dental check-ups',
    },
  ],
  upgrade,
};
